import versionCompare from 'tiny-version-compare';

function extractThunderbirdVersion(ua: string): string {
  const result = ua.trim().match(/Thunderbird\/(.*)/);
  if (result) {
    try {
      return result[1] || '';
    } catch (err) {
      console.error('Unable to parse ua', ua, err);
    }
  }
  return '';
}

//  "Mozilla/5.0 (Macintosh; Intel Mac OS X 10.16; rv:78.0) Gecko/20100101 Thunderbird/78.8.0 "
export default function getInfo(userAgent: string, minimumVersion: string) {
  // eslint-disable-next-line no-param-reassign
  userAgent = userAgent || '';
  const isThunderbird = userAgent.toLowerCase().indexOf('thunderbird') >= 0;
  const version = extractThunderbirdVersion(userAgent);
  let isSupported = false;
  if (version && version.length) {
    isSupported = versionCompare(version, minimumVersion.trim()) >= 0;
  }
  return { isThunderbird, isSupported, version };
}
